/* eslint-disable @typescript-eslint/naming-convention */

// types
import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { NativeLocalCart } from "@swiggy-private/cart-types";

// helpers
import { getAppliedPaymentCouponCode } from "@swiggy-private/cart-ui";
import { isEmpty } from "@swiggy-private/js-utils";

// constants
import { CouponTypeKeys } from "@cart-client/hooks/useLocalCartTransformer/constants";

export const mergePaymentCouponToLocalCart = (localCart: NativeLocalCart, reviewedCart: ReviewedCart | null) => {
    const paymentCoupon = getAppliedPaymentCouponCode(reviewedCart?.data);

    if (isEmpty(paymentCoupon)) {
        return localCart;
    }

    return {
        ...localCart,
        cart_saved_preferences: {
            ...localCart.cart_saved_preferences,
            paymentCouponCode: paymentCoupon,
        },
    };
};

export const unmergeCouponsFromLocalCart = (localCart: NativeLocalCart) => {
    const { cart_saved_preferences, couponCode } = localCart;
    const { paymentCouponCode, ...otherPreferences } = cart_saved_preferences || {};

    const cartUpdateCouponRequest = [];

    if (!isEmpty(couponCode)) {
        cartUpdateCouponRequest.push({
            coupon_type: CouponTypeKeys.RESTAURANT_COUPON,
            coupon_code: couponCode,
        });
    }

    if (!isEmpty(paymentCouponCode)) {
        cartUpdateCouponRequest.push({
            coupon_type: CouponTypeKeys.PAYMENT_COUPON,
            coupon_code: paymentCouponCode,
        });
    }

    return {
        ...localCart,
        couponCode,
        cart_saved_preferences: otherPreferences,
        cart_update_coupon_request: cartUpdateCouponRequest,
    };
};
